import {useCallback} from "react";
import {useAuthenticatedApi} from "@webng/react-app-common";
import {CommentList} from "./Models";
import {QueryFunction, useQuery} from "@tanstack/react-query";
import {ApiClient} from '@webng/tickaroo-api'

interface CommentListApiProps {
  ownerId: string
  channelId: string
  version?: number
}



type ChannelPreviewQueryKey = ["channelPreview", string, string]

export default function useChannelPreview({ownerId, channelId}: CommentListApiProps){
  const apiClient = useAuthenticatedApi();

  const queryFn: QueryFunction<CommentList, ChannelPreviewQueryKey> = useCallback(async ({queryKey}) => {
    const [, ownerId, channelId] = queryKey;
    return apiClient.get<CommentList>(ApiClient.API_COMMENTS_V1_PUBLIC_CHANNEL_COMMENTS, {
      ownerId: ownerId,
      channelId: channelId,
      limit: 3
    })
  }, [apiClient]);

  const {data, isError, isLoading, refetch, error} = useQuery<CommentList, Object, CommentList, ChannelPreviewQueryKey>({
    queryKey: ['channelPreview', ownerId, channelId],
    queryFn,
    retry: true,
    refetchInterval: 60000,
    refetchIntervalInBackground: false,
    staleTime: 60000
  })

  return {
    data: data?.items || [],
    total: data?.total,
    hasNextPage: !!data?.next,
    refetch: refetch,
    isError: isError,
    isLoading: isLoading,
    error: error
  }
}
